const BANK_ACCOUNT = 'bankAccount'
// const MPESA_ACCOUNT = 'mPesaAccount'
const MOBILE_MONEY_ACCOUNT = 'mobileMoneyAccount'
// const MTN_ACCOUNT = 'mtnAccount'
const VOUCHER = 'voucher'


export {
  BANK_ACCOUNT,
  // MPESA_ACCOUNT,
  MOBILE_MONEY_ACCOUNT,
  VOUCHER
  // MTN_ACCOUNT
}
